/**
 * /private-access — platform-scoped route shim for private access settings.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchCertificateRecordCheck } from "@/features/private-access-settings/queries";
import { queryKeys } from "@/lib/query-keys";
import { PrivateAccessSettingsPage } from "@/features/private-access-settings/pages/private-access-settings-page";

export const Route = createFileRoute("/_authed/private-access")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.privateAccess.certificateRecordCheck,
      queryFn: fetchCertificateRecordCheck,
    }),
  component: PrivateAccessSettingsPage,
});
